import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PageInfo from "./UI/PageInfo";
import THE_MULTIPLIER from "../../data/minimumWage/multiplier";

const MinimumWage = (props) => {
  const { input, formValues, schemaProps } = props;
  const {
    minimum_wage: { isState, state, state_code, per, per_code, label },
    hidden,
  } = schemaProps;

  const { stateMinWages, federalMinWage } = useSelector(
    (state) => state.referenceReducer
  );

  const [message, setMessage] = useState(
    `Please select a state in ${state_code} and a per value in ${per_code} to view the minimum wage`
  );

  const calculateWage = () => {
    let message = "";
    const state_value = formValues[state];
    const per_value = formValues[per];

    let wage = input.wage;
    const state_or_federal = isState ? `state's` : "federal";

    if (state_value === undefined || per_value === undefined) {
      message = `Please select a state in ${state_code} and a per value in ${per_code} to view your ${state_or_federal} minimum wage`;
      setMessage(message);
      return null;
    } else if (isState === true) {
      const minimum_hourly_wage = stateMinWages[state_value.toUpperCase()];

      if (per_value.toUpperCase() === "HOUR") {
        wage = minimum_hourly_wage;
      } else {
        const multiplier_obj = THE_MULTIPLIER.find(
          (o) => o.PER === per_value.toUpperCase()
        );
        const multiplier = multiplier_obj && multiplier_obj.MULTIPLIER;
        wage = minimum_hourly_wage * multiplier;
      }
    } else if (isState === false) {
      wage = federalMinWage[per_value.toUpperCase()];
    }

    if (input.value !== wage) {
      input.onChange(wage);
    }

    // need to display 2 decimals
    wage =
      Math.round(parseFloat((wage * Math.pow(10, 2)).toFixed(2))) /
      Math.pow(10, 2);

    message = `The ${
      isState ? "state" : "federal"
    } minimum wage ( per ${per_value.toLowerCase()} ) ${
      isState ? "for " + state_value + " is" : ""
    } $${wage}`;
    setMessage(message);
  };

  useEffect(() => {
    if (input.value === undefined) {
      calculateWage();
    }
  }, []); // ComponentDidMount equivalent

  useEffect(() => {
    calculateWage();
  }, [formValues[per], formValues[state]]); // ComponentDidUpdate equivalent

  return (
    <div style={hidden ? { display: "none" } : undefined}>
      <PageInfo
        coloring={`grey`}
        title={label}
        text={message}
        css={{ marginTop: "2rem" }}
        divider={false}
      />
    </div>
  );
};

export default MinimumWage;
